export const FirebaseConfig = {
	"projectId": "demouber-12144",
	"appId": "1:886664156409:web:d1356bc93bb0705cb5be28",
	"databaseURL": "https://demouber-12144-default-rtdb.firebaseio.com",
	"storageBucket": "demouber-12144.appspot.com",
	"locationId": "us-central",
	"apiKey": "AIzaSyBALHtYyeyHPcyN0fyZ_19DEoXgDyh_zBs",
	"authDomain": "demouber-12144.firebaseapp.com",
	"messagingSenderId": "886664156409"
};